import { AppAreaConfig } from '@/funnels/@types'
import pilatesFemale from './activity-female-pilates'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-asian-pilates',
	landing: {
		ids: ['loader-asian-pilates-f', 'age-asian-pilates-f'],
		route: {
			path: '/asian-pilates-f',
			name: 'female-asian-pilates-funnel',
		},
	},
	funnel: {
		id: 'ob-female-asian-pilates-fwf',
		route: {
			path: '/asian-pilates-f/ob/:page(.*)?',
			name: 'activity-female-asian-pilates',
		},
		slug: 'activity-female-asian-pilates',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: pilatesFemale,
				page: 'main-goal',
			},
		},
	},
}

export default appAreaConfig
